import createRoute   from '@widesk-ui/tools/createRoute';
import ShipmentModel from '@models/shop/ShipmentModel';

export default createRoute.dashboard('/entertainments/:entertainmentId/shipments', 'shop', 'ShipmentDashboard', ShipmentModel.localize());